var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-message"},[_c('p',{staticClass:"error-message__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }